  $(document).ready( function() {
  
    var txt = $("#purchase").val();
      //$("#inStockText").text(txt + " | pass")
      
    if (txt === "Add to cart") {
        
      $("#inStockText").text("In Stock");
        
    } else {
        
      $("#inStockText").text("");
        
    }
    
    $("#product-wrap").change( function() {
      
      txt = $("#purchase").val();
      //$("#inStockText").text(txt + " | pass")
      
      if (txt === "Add to cart") {
        
        $("#inStockText").text("In Stock");
        
      } else {
        
        $("#inStockText").text("");
        $("#inStockText").hide()
      }
      
    })
  
  });